import React from 'react';
import { PromotionCard } from './PromotionCard';

export const PromotionPage = ({ id }) => {
  return (
    <>
      <PromotionCard id={id} />
    </>
  );
};